import { enforceBoolean } from '../../../typing';
const enforceWithoutAcessors = (target, key) => {
    Object.defineProperty(target, key, {
        get() {
            return this[`_${key}`];
        },
        set(value) {
            this[`_${key}`] = enforceBoolean(value);
        },
        enumerable: true,
        configurable: true,
    });
};
/**
 * Decorator que força o valor de uma propriedade/método de classe para um valor booleano.
 *
 * @category Decorator
 *
 * @example
 * ```ts
 * import { EnforceBoolean } from '@ids/tools';
 *
 * export class ExampleClass {
 *
 *   @EnforceBoolean()
 *   disabled: boolean;
 *  }
 * }
 * ```
 */
export const EnforceBoolean = () => (target, key, propertyDescriptor) => {
    if (!!propertyDescriptor?.set && !!propertyDescriptor) {
        const originalSetter = propertyDescriptor.set;
        propertyDescriptor.set = function (value) {
            originalSetter.apply(this, [enforceBoolean(value)]);
        };
    }
    else {
        enforceWithoutAcessors(target, key);
    }
};
